import React from "react";
import PropTypes from "prop-types";

const Stars = ({ rating, cssClass }) => {
  const count = +rating;
  return (
    <div className={cssClass}>
      { function() {
        let stars = [];
        for (let i=0; i<count; i++) {
          stars.push(<span key={'Star' + i + rating + Math.random()*i*10}/>)
        }
        return stars;
      }()}

    </div>
  )
};

export default Stars;

Stars.propTypes = {
  rating: PropTypes.string,
  cssClass: PropTypes.string,
};
